import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Publisher} from '../../../../../shared/domain/publisher.model';
import {AlertMetric} from '../../../domain/alerts/alert-metric.enum';
import {KeyLabel} from '../../../../../shared/domain/key-label.model';
import {AlertReportTypes} from '../../../domain/alerts/alert-report-type.enum';
import {DateRangeHolder} from '../../../../../shared/domain/date-range-holder.model';
import {DateRangeType} from '../../../../../shared/domain/date-range-type.enum';
import {WidgetAlertsSettings} from './widget-alerts-settings.model';

@Component({
  selector: 'cm-widget-alerts-settings-dialog',
  template: `
    <h1 mat-dialog-title>Alets widget settings</h1>
    <div mat-dialog-content>
      <div class="row mb-4 d-md-none">
          <div class="col">
	          <cm-publisher-autocomplete-chips
			          [publisherIds]="settings.request.filter.publisherIds"
			          (publisherSelectionChange)="onPublisherSelected($event)">
	          </cm-publisher-autocomplete-chips>
          </div>
      </div>
      <div class="row mb-4">
        <div class="col mb-4">
          <mat-radio-group [(ngModel)]="settings.request.reportType" class="d-flex flex-column">
            <mat-radio-button *ngFor="let type of AlertReportTypes" [value]="type.key" class="mb-0">{{type.label}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col">
          <cm-date-range-chooser [dateTo]="settings.request.filter.dateTo"
                                 [autoSubmitCustomDate]="true"
                                 [dateFrom]="settings.request.filter.dateFrom"
                                 [allowedDateRangeTypes]="allowedDateRangeTypes"
                                 (dateRangeChanged)="onDateRangeChanged($event)">
          </cm-date-range-chooser>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">

          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text" placeholder="Impression drop bellow"
                   (input)="setInputMetric(AlertMetric.IMPRESSIONS_DROP_PERCENT, settings.request.filter.impressionsDropPercent)"
                   [(ngModel)]="settings.request.filter.impressionsDropPercent"/>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text" placeholder="Impressions over"
                   [disabled]="!hasMetric(AlertMetric.IMPRESSIONS_DROP_PERCENT)"
                   [(ngModel)]="settings.request.filter.impressionsOver"/>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text" placeholder="Revenue drop percent"
                   (input)="setInputMetric(AlertMetric.REVENUE_DROP_PERCENT, settings.request.filter.revenueDropPercent)"
                   [(ngModel)]="settings.request.filter.revenueDropPercent"/>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text" placeholder="Revenue over"
                   [disabled]="!hasMetric(AlertMetric.REVENUE_DROP_PERCENT)"
                   [(ngModel)]="settings.request.filter.revenueOver"/>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text" placeholder="Refresh drop percent"
                   (input)="setInputMetric(AlertMetric.REFRESH_DROP_PERCENT, settings.request.filter.refreshDropPercent)"
                   [(ngModel)]="settings.request.filter.refreshDropPercent"/>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field class="w-100" floatLabel="always">
            <input matInput type="text"
                   (input)="setInputMetric(AlertMetric.REVENUE_DROP_AMOUNT, settings.request.filter.revenueDropAmount)"
                   placeholder="Revenue drop amount"
                   [(ngModel)]="settings.request.filter.revenueDropAmount"/>
            <span matSuffix>$</span>
          </mat-form-field>
        </div>
        <div class="col-md-4 flex-column">
          <mat-checkbox [checked]="hasMetric(AlertMetric.IMPRESSIONS_STOPPED_DELIVERING)"
                        (change)="setMetric(AlertMetric.IMPRESSIONS_STOPPED_DELIVERING, $event.checked)">Impressions
            stopped delivering
          </mat-checkbox>
          <mat-checkbox [checked]="hasMetric(AlertMetric.REVENUE_STOPPED_DELIVERING)"
                        (change)="setMetric(AlertMetric.REVENUE_STOPPED_DELIVERING, $event.checked)">Revenue stopped
            delivering
          </mat-checkbox>
          <mat-checkbox [checked]="hasMetric(AlertMetric.REVENUE_DP_STOPPED_DELIVERING)"
                        (change)="setMetric(AlertMetric.REVENUE_DP_STOPPED_DELIVERING, $event.checked)">Revenue DP
            stopped
            delivering
          </mat-checkbox>
        </div>
        <div class="col-md-4 d-none d-md-inline-flex">
          <cm-publisher-autocomplete-chips
            [publisherIds]="settings.request.filter.publisherIds"
            (publisherSelectionChange)="onPublisherSelected($event)">
          </cm-publisher-autocomplete-chips>
        </div>

      </div>
    </div>
    <mat-dialog-actions class="d-flex justify-content-center">
	    <button mat-raised-button mat-dialog-close cdkFocusInitial>Cancel</button>
      <button mat-raised-button color="primary" (click)="save()">Save</button>
    </mat-dialog-actions>

  `,
})
export class WidgetAlertsSettingsDialogComponent {

  settings: WidgetAlertsSettings;
  AlertReportTypes: KeyLabel[] = <KeyLabel[]> AlertReportTypes;

  AlertMetric = AlertMetric;
  allowedDateRangeTypes = [
    DateRangeType.TODAY,
    DateRangeType.YESTERDAY,
    DateRangeType.THIS_WEEK,
    DateRangeType.LAST_7_DAYS,
  ];

  constructor(public dialogRef: MatDialogRef<WidgetAlertsSettingsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.settings = data.settings ? JSON.parse(JSON.stringify(data.settings)) : new WidgetAlertsSettings();
  }

  hasMetric(metric: AlertMetric) {
    return this.settings.request.metrics.includes(metric);
  }

  setMetric(metric: AlertMetric, checked: boolean) {
    const index = this.settings.request.metrics.indexOf(metric);
    if (!checked) {
      if (index != -1) {
        this.settings.request.metrics.splice(index, 1);
      }
    } else {
      if (index == -1) {
        this.settings.request.metrics.push(metric);
      }
    }
  }

  setInputMetric(metric: AlertMetric, data) {
    if (data) {
      this.setMetric(metric, true);
    } else {
      this.setMetric(metric, false);
    }
  }

  onPublisherSelected(publishers: Publisher[]) {
    this.settings.request.filter.publisherIds = publishers.map(p => p.id);
  }

  onDateRangeChanged(dates: DateRangeHolder) {
    this.settings.request.filter.dateFrom = dates.dateFrom;
    this.settings.request.filter.dateTo = dates.dateTo;
    this.settings.dateRange = dates;
  }

  save() {
    this.dialogRef.close(this.settings);
  }

}

